import { render } from "./SyncList.vue?vue&type=template&id=3fdd1758&scoped=true"
import script from "./SyncList.vue?vue&type=script&lang=ts"
export * from "./SyncList.vue?vue&type=script&lang=ts"

import "./SyncList.vue?vue&type=style&index=0&id=3fdd1758&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fdd1758"

export default script